/**
 *
 * Login Controller
 */

"use strict";

require(["commonController"], function () {});

function initializeLoginCtrl()
{
    require(
            ['jquery', 'checkFeatures', 'Seed', 'Seed.Ajax'],
            function ($, checkFeatures, Seed) {

                // Focus sur login
                var logininput = document.getElementById('login');
                if (logininput) {
                    logininput.focus();
                }

                $("#connexionForm").submit(function () {
                    // a la soumission du formulaire
                    Seed.Ajax.Post({
                        url: root + "source/php_common/Login.php",
                        data: "login=" + $("#login").val()
                                + "&pass=" + $("#pass").val()
                                + "&moduleType=" + moduleType,
                        async: true,
                        success: function (msg) {
                            if (msg === "success") {
                                $("#alert")
                                        .html(MSG_SUCCESS)
                                        .removeClass("alert-danger")
                                        .addClass('alert-success')
                                        .show();
                                if (moduleType === "ServiceMaint") {
                                    location.assign('source/eservices.php');
                                } else {
                                    location.assign('source/index.php');
                                }
                            } else {
                                $("#alert").html(msg).show();
                            }
                        }
                    });
                    // permet de rester sur la meme page a
                    // la soumission du formulaire
                    return false;
                });

                var dateSupport = checkFeatures.checkInput('date')
                        && checkFeatures.isPhoneOrTablet();
                var numberSupport = checkFeatures.checkInput('number')
                        && checkFeatures.isPhoneOrTablet();
                var timeSupport = checkFeatures.checkInput('time')
                        && checkFeatures.isPhoneOrTablet();
                var datetimeSupport = checkFeatures.checkInput('datetime-local')
                        && checkFeatures.isPhoneOrTablet();
                var smallDevice = checkFeatures.isSmallDevice();
                var isIos = checkFeatures.isIos();
                Seed.Ajax.Post({
                    url: root + "source/php_common/sessionWrite.php",
                    data: "supportDate=" + dateSupport
                            + "&supportNumber=" + numberSupport
                            + "&supportTime=" + timeSupport
                            + "&supportDatetime=" + datetimeSupport
                            + "&isSmallDevice=" + smallDevice
                            + "&isIos=" + isIos,
                    async: true
                });
            },
            function (err) {
                console.error("ERROR: ", err.requireType);
                console.error("MODULES: ", err.requireModules);
            }
    );

}
;
define("loginController", function(){});

